import { identity } from '../identity.ts';
import { formatError, Logger } from './logger.ts';

/**
 * TODO: Requires frontendConfig or similar and log to graylog.
 */
export class FrontendLogger implements Logger {
  public error = (message: unknown, ...optionalParams: unknown[]): void => {
    const formatted = `${message} ${optionalParams
      .filter(identity)
      .map(p => formatError(p))
      .join(' ')}`;

    // console.error(formatted);
  };
}
